<template>
  <Modal
    v-model="modalShow"
    :width="modalWidth"
    :title="modalTitle"
    :footer-hide="true"
    :closable="false"
    @on-visible-change="getModalChange"
  >
    <slot></slot>
    <Table
      ref="dataTable"
      border
      :columns="tableColumnShow"
      :data="tableData"
      :loading="loading"
      @on-row-click="selectRow"
      @on-select="selectOneData"
      @on-select-cancel="cancelOneData"
      @on-select-all="selectAllData"
      @on-select-all-cancel="cancelAllData"
      @on-selection-change="selectMoreData"
    >
      <template slot="radio" slot-scope="{ row }">
        <Radio
          :disabled="!!row._disabled"
          :value="row.id === singleSelectedId"
        ></Radio>
      </template>
    </Table>
    <Page
      v-if="showPage"
      :total="tableTotal"
      show-total
      :current="tableCurrent"
      class="page-right"
      @on-change="changePage"
    ></Page>
    <div class="modal-footer">
      <Button @click="handleCancleBtn">取消</Button>
      <Button type="primary" @click="handleSureBtn">确定</Button>
    </div>
  </Modal>
</template>
<script>
export default {
  props: {
    // 弹窗的标题
    modalTitle: {
      type: String,
      default: ''
    },
    // 弹窗表格的column
    tableColumn: {
      type: Array,
      default: () => []
    },
    // 弹窗表格的数据 数据里面需要有一个id的字段
    tableData: {
      type: Array,
      default: () => []
    },
    // 表格数据的总数量
    tableTotal: {
      type: Number,
      default: 0
    },
    // 表格数据的当前第几页
    tableCurrent: {
      type: Number,
      default: 1
    },
    selectType: {
      type: Number,
      default: 1 // 1代表表格单选，2代表表格多选
    },
    canSelfClose: {
      type: Boolean,
      default: true
    },
    showPage: {
      type: Boolean,
      default: true
    }, // 是否展示分页
    modalWidth: {
      type: Number,
      default: 800
    },
    loading: {
      type: Boolean,
      default: false // 数据是否在加载
    }
  },
  data() {
    return {
      modalShow: false,
      singleSelectedId: '', // 选中的id(针对单选的)
      singleSelectData: {}, // 选中的数据(针对单选的)
      moreCheckSelectData: [] // 多选的时候选中的数据
    };
  },
  computed: {
    tableColumnShow() {
      // 添加表格单选框
      const selectArray = [{
        title: ' ',
        slot: 'radio',
        width: 60,
        fixed: 'left'
        // render: (h, params) => {
        //   let flag = false;
        //   flag = params.row.id === this.singleSelectedId;
        //   return h('div', [
        //     h('Radio', {
        //       props: {
        //         value: flag,
        //         disabled: !!params.row._disabled
        //       }
        //     })
        //   ]);
        // }
      }];
      // 添加表格多选框
      const selectMore = [
        {
          type: 'selection',
          width: 60,
          align: 'center',
          fixed: 'left'
        }
      ];
      if (this.selectType === 1) {
        return selectArray.concat(this.tableColumn);
      } else {
        return selectMore.concat(this.tableColumn);
      }
    }
  },
  watch: {
    tableData: {
      handler(newVal, oldVal) {
        const seletObj = newVal.find(item => {
          return item.id === this.singleSelectedId;
        });
        this.singleSelectData = seletObj || {};
      },
      deep: true
    }
  },
  methods: {
    // 打开弹窗
    open(id) {
      id ? this.singleSelectedId = id : '';
      if (id) {
        this.singleSelectedId = id;
        console.log(this.tableData, '拿到的数据=====');
        const seletObj = this.tableData.find(item => {
          return item.id === this.singleSelectedId;
        });
        this.singleSelectData = seletObj || {};
      }
      this.modalShow = true;
      console.log('id', id);
    },
    // 关闭弹窗
    close() {
      this.modalShow = false;
    },
    // 点击了分页页码
    changePage(page) {
      this.$emit('pageChange', page);
    },
    // 获取弹窗的状态变化 如果弹窗关闭，就清楚掉选择的数据
    getModalChange(status) {
      if (!status && this.selectType === 1) {
        this.singleSelectedId = '';
        this.singleSelectData = {};
      }
    },
    // 点击了确定按钮,传递正确数据
    handleSureBtn() {
      if (this.selectType === 1) {
        this.singleCheck();
      } else {
        this.moreCheck();
      }
    },
    // 表格只能单选的时候点击确定按钮执行操作
    singleCheck() {
      if (JSON.stringify(this.singleSelectData) === '{}') {
        return this.$Message.error('请先选择！');
      }
      this.$emit('emitSelectData', this.singleSelectData);
      if (this.canSelfClose) {
        this.close();
      }
    },
    // 表格是多选的时候点击确定按钮执行操作
    moreCheck() {
      // if (this.moreCheckSelectData.length === 0) {
      //   return this.$Message.error('请先选择！');
      // }
      this.$emit('emitSelectData', this.moreCheckSelectData);
      this.close();
    },
    // 点击取消按钮
    handleCancleBtn() {
      if (this.selectType === 2) {
        this.moreCheckSelectData = [];
      }
      this.close();
    },
    // 选择某一行
    selectRow(row, index) {
      if (row._disabled) {
        return;
      }
      this.singleSelectedId = row.id;
      this.singleSelectData = row;
      // 多选的时候，加多这个可以点击整行也勾选或者去掉勾选
      if (this.selectType === 2) {
        this.$refs.dataTable.toggleSelect(index);
      }
    },
    // 多选状态下勾选了一条数据
    selectOneData(_, row) {
      this.$emit('pickOneData', row);
    },
    // 多选状态下取消了一条数据
    cancelOneData(_, row) {
      this.$emit('dropOneData', row);
    },
    // 多选状态下勾选全部数据
    selectAllData(selection) {
      this.$emit('pickAllData', selection);
    },
    cancelAllData(_) {
      this.$emit('dropAllData');
    },
    // 表格是多选的时候触发
    selectMoreData(selection) {
      // console.log(selection, '是啥0----');
      this.moreCheckSelectData = selection;
    }
  }
};
</script>
<style lang="scss" scoped>
.page-right {
  text-align: right;
  margin-top: 16px;
}
.modal-footer {
  margin-top: 32px;
  text-align: right;
  button + button {
    margin-left: 16px;
  }
}
</style>
